export default __webpack_public_path__ + "static/media/info.8ca39ba6.svg";